import { render, staticRenderFns } from "./collectionRecord.vue?vue&type=template&id=44fac542&scoped=true&"
import script from "./collectionRecord.vue?vue&type=script&lang=js&"
export * from "./collectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./collectionRecord.vue?vue&type=style&index=0&id=44fac542&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fac542",
  null
  
)

export default component.exports